export enum PaymentMethodType {
  CreditCard = 1,
  ACH = 2,
}
